<div class="buy-cover-covered-call-rebalance-settings">
  <div class="flex-row">
    <div class="flex-column flex-column-header  flex-search-securities-header">
      <strong>Options</strong>
    </div>
    <div class="flex-column fixed-width-column">
      <div class="flex-securities-search-container">
        <div class="search-add-container">
          <div class="search-symbol-header">Select Underlying Symbol</div>
          <div>
            <irb-dropdown-search #buyToCoverSecurityDropdown
              (search)="populateSecuritiesDropdown($event)"
              (selection)="onUnderlyingSymbolSelect($event)"
              (clearSelection)="clearBuyToCoverSecurity()"
              [size]="15"
            ></irb-dropdown-search>
          </div>
          <div>
            <button id="underlyingSymbolAddButton" class="btn-medium-secondary btn-spacer"
              [disabled]="(underlyingSymbol === null || underlyingSymbol === undefined) || isReadOnly"
            (click)="addUnderlyingSymbol()">Add</button>
            <button id="editorCreateNewButton" (click)="onCreateNewSecurity()"
            class="btn-medium-secondary" [disabled]="isReadOnly">New Security</button>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="flex-row zero-bottom-margin">
    <div class="flex-column flex-column-header">
      <strong>Buy using cash above:</strong>
    </div>
    <div class="flex-column">
      <div class="checkboxes-horizontal-align">
        <div class="flex-radio-item">
          <div>
            <div><p-radioButton name="buyUsingCashTarget" inputId="buytcitem1" [value]="true"
              [(ngModel)]="isCashTarget" [disabled]="isReadOnly" (ngModelChange)="onCashMinTargetChange();">
            </p-radioButton>
              <label for="buytcitem1" >Cash target</label>
            </div>
            <div>
              Only the cash exceeding an account's<br>
              cash target will be used for the buy.<br>
              (Set-aside cash is never used for this.)
            </div>
          </div>

        </div>
        <div class="flex-radio-item">
          <div>
            <div>
              <p-radioButton name="buyUsingCashMinimum" inputId="buytcitem2" [value]="false"
                [(ngModel)]="isCashTarget" [disabled]="isReadOnly" (ngModelChange)="onCashMinTargetChange();">
              </p-radioButton>
                <label for="buytcitem2" >Cash minimum</label>
            </div>
            <div>
              All the cash exceeding an account's minimum<br>
              cash value will be used for the buy.<br>
              (Set-aside cash is never used for this.)
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="flex-row">
    <div class="flex-column flex-column-header  flex-option-settings-header">
      <strong>Options settings</strong>
      <span class="tooltipIcon infoIcon suggested-name" calltoaction calltoactionPosition="right"
      [calltoactionTemplate]="optionSettingsInfoToolTipIcon"></span>
    </div>
    <div class="flex-column">
      <div class="flex-option-settings-container">
        <div class="option-settings-row-container">
          Specify values to apply to all securities listed below (optional)
        </div>
        <div class="option-settings-row-container">
          <div class="option-settings-column-container">

            <div class="option-settings-header">Percent of option to close:</div>
            <div><irb-number-text-box [(value)]="defaultPercentOfOptionToBuyBack" places="2" min="1"
              max="100" [isPercentage]="true" [disabled]="isReadOnly"
            width="80px"></irb-number-text-box>
          </div>
          <div>%</div>
          <div><button id="applyPercentOfOptionToBuyBack"  class="btn-medium-secondary btn-spacer"
          (click)="applyPercentOfOptionToBuyBack()" [disabled]="isReadOnly || this?.data?.allocations?.length ===0">Apply</button></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="flex-row">
  <div class="flex-column flex-column-header"></div>
  <div class="flex-column">
    @if (!isUiTest) {
      <div style="width:100%">
        <irb-inventory-grid class="buy-to-cover-grid" [style.width]="'800px'" [style.height]="'200px'" [gridHeight]="'200px'"
          [showSideBar]="false" [gridOptions]="gridOptions"
          [frameworkComponents]='frameworkComponents' (gridReady)="onGridReady($event)">
        </irb-inventory-grid>
      </div>
    }
  </div>
</div>
</div>
<ng-template #optionSettingsInfoToolTipIcon>
  <div>
    After selecting options chains, you can use these to quickly apply the same
    percentages for all symbols, so you don't have to enter the same settings
    for each security. You can edit the settings for any individual security
    after applying these same settings to all.
  </div>
</ng-template>
